import { render, staticRenderFns } from "./DataTableCorporateHistoric.vue?vue&type=template&id=d2292816&"
import script from "./DataTableCorporateHistoric.vue?vue&type=script&lang=js&"
export * from "./DataTableCorporateHistoric.vue?vue&type=script&lang=js&"
import style0 from "./DataTableCorporateHistoric.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
